/* Dynamic Plot code copyright 2024 (c) Tuva Labs Inc. */
/**
 *
 * created by cmiller, based on DataTypeComponent.jsx
 * Adds fields to control formatting of fractions in an attribute.
 */

import React from 'react';
import ToolTip from '../common/ToolTip';
import Toggle from "react-toggle";

class FractionOptionsComponent extends React.Component {
    constructor (props) {
        super(props);
        let Dyn = this.props.Dyn,
            attribute = this.props.attributeObj,
            formatString = attribute.getFormatString();
        Dyn.assert( attribute.getDataType(true)==='numerical:fraction')
        this.state = {
            isUnsimplified: Dyn.fractionData.wantUnsimplifiedFractions( formatString ),
            isImproper: Dyn.fractionData.wantImproperFractions( formatString ),
            denominator: Dyn.fractionData.formatStringToDenominator( formatString ),
        };
        this.validDenominator = this.state.denominator;
    }

    onChange = ( value, type ) => {
        let Dyn = this.props.Dyn;
        //console.log( "onChange", type, value );
        if( type==='simplified' ) {
            this.setState(
                { isUnsimplified: ! value },
                () => { this.propagateStateChange() });
        } else if( type==='proper' ) {
            this.setState(
                { isImproper: ! value },
                () => { this.propagateStateChange() });
        } else if( type==='denom') {
            // update the state immediately but validate later, onTypeDelay()
            this.setState(
                { denominator: value }, // note: may not be a valid denominator yet
                () => {
                    if(this.inputChangeTimeout) {
                        clearTimeout(this.inputChangeTimeout);
                    }
                    this.inputChangeTimeout = setTimeout(function(){
                        this.onTypeDelay();
                    }.bind(this), 500);
                });
        }
    }

    onTypeDelay = () => {
        // only propagate denominator changes if the value is valid
        let Dyn = this.props.Dyn,
            d = Dyn.mathUtil.clipToMinMax( 1, Dyn.fractionData.maxUserDenominator, this.state.denominator );
        if( Dyn.fractionData.isValidDenominator( d )) {
            this.validDenominator = d;
            this.propagateStateChange();
        }
    }

    onBlur = ( eleName ) => {
        // restore the last valid denominator, if needed, if leaving field with invalid values
        setTimeout(() => {
            if( this.state.denominator !== this.validDenominator ) {
                this.setState(
                    { denominator: this.validDenominator },
                    () => { this.propagateStateChange() });
            }
        }, 500);
    }

    propagateStateChange = () => {
        let Dyn = this.props.Dyn,
            formatString = Dyn.fractionData.setFormatString(
                this.validDenominator, this.state.isUnsimplified, this.state.isImproper );
        //console.log( "FractionOptionsComponent.propagateStateChange", formatString );
        this.props.handleChange({
            component: 'fraction-options',
            attributeObj: this.props.attributeObj,
            formatString: formatString
        });
    }

    getLoc = (str) => {
        return this.props.Dyn.loc( str );
    }

    unitTest = () => {
        // add unit tests here
        return true;
    }

  render = () => {
    let Dyn = this.props.Dyn,
        simplifiedLabel = this.getLoc("Simplified Fractions"),
        simplifiedTip = this.getLoc( "Show simplified fractions, e.g. 1/2 instead of 2/4"),
        properLabel = this.getLoc("Proper Fractions"),
        properTip = this.getLoc( "Show proper fractions, e.g. '1 2/3' instead of '5/3'");
    if( ! this.unitTestHasRun ) {
        this.unitTestHasRun = this.unitTest();
    }
    return (
      <div className={"tde-data-type-component tde-row tde-mt-2" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
          <div className="tde-row tde-mb-2">
              <div className="tde-label tde-mb-1">{ this.getLoc('Denominator') }:</div>
              <input type="text" className="tde-input tde-input-text"
                     aria-label={this.getLoc('Denominator')}
                     onChange={e => {this.onChange(e.target.value, 'denom')}}
                     onBlur={e => {this.onBlur('denom')}}
                     value={this.state.denominator} />
          </div>
          <div className="tde-py-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
              <label className="text-normal flex-1" htmlFor="tde-simplified-fractions-toggle">
                { simplifiedLabel }
                <ToolTip
                    tip={ simplifiedTip }
                    dir="r"
                    Dyn={Dyn} >
                    <i role="button" className="tde-i tde-i-exclamation tde-ml-2"
                        aria-label={ simplifiedTip }>
                    </i>
                </ToolTip>
              </label>
              <Toggle
                  aria-label={`${simplifiedLabel}, ${!this.state.isUnsimplified ? 'checked' : 'unchecked'}, checkbox`}
                  id="tde-simplified-fractions-toggle"
                  className="black-toggle"
                  checked={ !this.state.isUnsimplified }
                  icons={false}
                  onChange={ (e) => { this.onChange(e.target.checked,'simplified'); }}
              />
          </div>

          <div className="tde-py-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
              <label className="text-normal flex-1" htmlFor="tde-proper-fractions-toggle">
                    { properLabel }
                    <ToolTip
                        tip={ properTip }
                        dir="r"
                        Dyn={Dyn} >
                        <i role="button" className="tde-i tde-i-exclamation tde-ml-2"
                           aria-label={ properTip }>
                        </i>
                    </ToolTip>
              </label>
              <Toggle
                  aria-label={`${properLabel}, ${!this.state.isImproper ? 'checked' : 'unchecked'}, checkbox`}
                  id="tde-proper-fractions-toggle"
                  className="black-toggle"
                  checked={ !this.state.isImproper }
                  icons={false}
                  onChange={ (e) => { this.onChange(e.target.checked,'proper'); }}
              />
          </div>
      </div>
    );
  }
}

export default FractionOptionsComponent;
